// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base[data-v-1c360572]{text-align:center;vertical-align:middle;position:relative;height:2rem;width:-moz-fit-content;width:fit-content}.badge[data-v-1c360572]{position:absolute;top:0;right:0;display:flex;font-size:12px;line-height:1;border-radius:50%;align-items:flex-start;justify-content:flex-end}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
